// extracted by mini-css-extract-plugin
export default {"content":"style_content__cHntC","leftSide":"style_leftSide__fBGdH","rightSide":"style_rightSide__HYSeb","type":"style_type__89VHw"};